import { createContext } from "react";

const recipeDataContext = createContext();

export default recipeDataContext;
